import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

import {
  COOKIE_CONSENT_EVENT,
  getStoredCookieConsent,
} from "../utils/cookieConsent";
import {
  initializeTracking,
  trackingConfiguration,
  trackPageView,
  trackSearch,
} from "../utils/analytics";

const AnalyticsTracker = () => {
  const location = useLocation();
  const lastTrackedRouteRef = useRef("");
  const [consent, setConsent] = useState(() =>
    getStoredCookieConsent()
  );

  useEffect(() => {
    const handleConsentUpdate = (event) => {
      setConsent(event.detail || getStoredCookieConsent());
    };

    window.addEventListener(
      COOKIE_CONSENT_EVENT,
      handleConsentUpdate
    );

    return () => {
      window.removeEventListener(
        COOKIE_CONSENT_EVENT,
        handleConsentUpdate
      );
    };
  }, []);

  useEffect(() => {
    if (!consent) return;

    initializeTracking({
      analytics: consent.analytics === true,
      marketing: consent.marketing === true,
    });

    const hasAllowedTracker =
      (consent.analytics === true &&
        trackingConfiguration.hasGoogleAnalytics) ||
      (consent.marketing === true &&
        trackingConfiguration.hasMetaPixel);

    if (!hasAllowedTracker) return;

    const routeKey = `${location.pathname}${location.search}`;

    if (lastTrackedRouteRef.current === routeKey) return;

    lastTrackedRouteRef.current = routeKey;

    trackPageView({
      path: routeKey,
      title: document.title,
    });

    const searchTerm = new URLSearchParams(location.search).get(
      "search"
    );

    if (location.pathname === "/shop" && searchTerm) {
      trackSearch(searchTerm);
    }
  }, [consent, location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
